module.exports = __webpack_public_path__ + "static/media/td.873d5c4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/td.svg
// module id = 260
// module chunks = 0